import adminApiClient from './adminApiClient';

export const adminService = {
  login: (username, password) =>
    adminApiClient
      .post('/admin/auth/login', { username, password })
      .then((res) => res.data),
  getWallet: () =>
    adminApiClient.get('/admin/wallet').then((res) => res.data),
  getDashboard: () =>
    adminApiClient.get('/admin/dashboard').then((res) => res.data),
  getTransactions: (params) =>
    adminApiClient
      .get('/admin/wallet/transactions', { params })
      .then((res) => res.data),
  getDrawLocks: (params) =>
    adminApiClient.get('/admin/draw-locks', { params }).then((res) => res.data),
  createDrawLock: (payload) =>
    adminApiClient.post('/admin/draw-locks', payload).then((res) => res.data),
  updateDrawLock: (id, payload) =>
    adminApiClient.patch(`/admin/draw-locks/${id}`, payload).then((res) => res.data),
  getDrawLockAudits: (id) =>
    adminApiClient
      .get(`/admin/draw-locks/${id}/audits`)
      .then((res) => res.data),
  getLotteryBets: (params) =>
    adminApiClient
      .get('/admin/bets/lottery', { params })
      .then((res) => res.data),
  getYikiBets: (params) =>
    adminApiClient.get('/admin/bets/yiki', { params }).then((res) => res.data),
  getLaoBets: (params) =>
    adminApiClient.get('/admin/bets/lao', { params }).then((res) => res.data),
  getSoiDaoBets: (params) =>
    adminApiClient
      .get('/admin/bets/soi-dao', { params })
      .then((res) => res.data),
  getUsers: (params) =>
    adminApiClient.get('/admin/users', { params }).then((res) => res.data),
  setUserSale: (id, isSale) =>
    adminApiClient
      .patch(`/admin/users/${id}/sale`, { isSale })
      .then((res) => res.data),
};
